<div *ngIf="isCounterAvailableToShow" class="new-indicator new-indicator-app"><span>{{ warningCount }}</span></div>